import { render } from "./Index.vue?vue&type=template&id=b6f70480"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=b6f70480&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Vendors/Calendar/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6f70480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6f70480', __exports__)) {
    api.reload('b6f70480', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=b6f70480", () => {
    api.rerender('b6f70480', render)
  })

}


export default __exports__